export const FETCH_REPRESENTATIVES = 'FETCH_REPRESENTATIVES';
export const FETCH_SPECIALTIES = 'FETCH_SERVICES';
export const FETCH_SPECIALTIES_FAILED = 'FETCH_SERVICES_FAILED';
export const FETCH_SPECIALTIES_DONE = 'FETCH_SERVICES_DONE';

export const SEARCH_QUERY_UPDATED = 'SEARCH_QUERY_UPDATED';
export const SEARCH_QUERY_COMMITED = 'SEARCH_QUERY_COMMITED';
export const MOCK_SEARCH = 'MOCK_SEARCH';
export const MOCK_SEARCH_PAGE_2 = 'MOCK_SEARCH_PAGE_2';
export const SORT_TYPE_UPDATED = 'SORT_TYPE_UPDATED';
export const SORT_SEARCH_RESULTS = 'SORT_SEARCH_RESULTS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const CLEAR_SEARCH_TEXT = 'CLEAR_SEARCH_TEXT';

export const SEARCH_STARTED = 'SEARCH_STARTED';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const SEARCH_COMPLETE = 'SEARCH_COMPLETE';

export const GEOCODE_STARTED = 'GEOCODE_STARTED';
export const GEOCODE_FAILED = 'GEOCODE_FAILED';
export const GEOCODE_COMPLETE = 'GEOCODE_COMPLETE';

export const CLEAR_ERROR = 'CLEAR_ERROR';

export const GEOLOCATE_USER = 'GEOLOCATE_USER';

export const MAP_MOVED = 'MAP_MOVED';

export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
export const FETCH_ORGANIZATIONS_DONE = 'FETCH_ORGANIZATIONS_DONE';
export const FETCH_ORGANIZATIONS_FAILED = 'FETCH_ORGANIZATIONS_FAILED';
